import { FC } from 'react'
import { EditorWrapper, EditorWrapperType } from './Wrapper'
import { FormItem, FormItemType } from './FormItem'

export const Form: FC & EditorWrapperType & FormItemType = (): JSX.Element => (
  <></>
)

Form.Wrapper = EditorWrapper
Form.FormItem = FormItem
